import { buildSnippetAnchorTerms } from '@/lib/academySearch/utils/buildSnippetAnchorTerms'

export function buildSearchMatchTerms(query: string): string[] {
  const trimmed = query.trim()
  if (!trimmed) {
    return []
  }

  const parts = trimmed
    .toLowerCase()
    .split(/\s+/)
    .filter((term) => term.length > 0)
  const seen = new Set<string>()
  const terms: string[] = []

  for (const term of [trimmed, ...buildSnippetAnchorTerms(parts)]) {
    const key = term.toLowerCase()
    if (!term || seen.has(key)) {
      continue
    }

    seen.add(key)
    terms.push(term)
  }

  return terms
}
